import * as yup from 'yup';

function companyType(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_COMPANYTYPE_FIELD_IS_REQUIRED',
      defaultMessage: 'Company Type is required',
    }),
  );
}

function companyNumber(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'CREATEFORM_COMPANYNUMBER_FIELD_IS_REQUIRED',
        defaultMessage: 'Company Number is required',
      }),
    )
    .max(
      32,
      formatMessage({
        id: 'CREATEFORM_COMPANYNUMBER_FIELD_MAX_CHARS_32',
        defaultMessage: 'Company Number should be less than 32 chars',
      }),
    );
}

function companyNumberInternal(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'CREATEFORM_COMPANYNUMBERINTERNAL_FIELD_IS_REQUIRED',
        defaultMessage: 'Company Number Internal is required',
      }),
    )
    .max(
      32,
      formatMessage({
        id: 'CREATEFORM_COMPANYNUMBERINTERNAL_FIELD_MAX_CHARS_32',
        defaultMessage: 'Company Number Internal should be less than 32 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_STATUS_FIELD_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      companyType: companyType(formatMessage),
      companyNumber: companyNumber(formatMessage),
      companyNumberInternal: companyNumberInternal(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
